import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectReport, Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reports: Identifiable<ProjectReport>[];
  retrieveProjectReports(
    project: Boundaries["retrieveProjectReports"]["request"],
  ): void;
}

function useRetrieveProjectReports(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectReportsRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectReportsRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectReportsRequestFailure(project),
    ),
    reports: useSelector(() => selector.getProjectReports(project)),
    retrieveProjectReports: core.retrieveProjectReports,
  };
}

export { useRetrieveProjectReports };
